<div
  *ngIf="!loading() && projectDetail()"
  class="w-full">
  <div class="flex w-full justify-between mt-6 border-b border-neutral-300 sticky top-0 bg-white py-4 z-50">
    <span class="text-[18px] font-black">
      <i
        class="pi pi-file-edit"
        style="font-size: 2rem"></i>
      SUBSANACIÓN DE PROYECTO
    </span>

    <div class="flex gap-4">
      <app-buttons
        [label]="'Cancelar'"
        (click)="backPage()" />

      <app-buttons
        [label]="'Enviar a aprobación'"
        [classes]="'bg-primary-base text-primary-light disabled:bg-primary-base disabled:opacity-75'"
        [disabled]="!canSubmitCorrection() || hasInvalidObservedFields()"
        (click)="confirm()"
        type="button" />
    </div>
  </div>
  <form
    [formGroup]="form"
    (ngSubmit)="onSave()"
    class="flex flex-col">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col py-4 gap-4">
        <span class="text-2xl font-bold">Revisa todos los campos del proyecto</span>
        <span class="text-sm">
          Selecciona los campos que consideres incorrectos o bien necesitan revisión por parte de la persona que
          solicita el alta del proyecto. Es posible que veas campos ya seleccionados, esto se debe a que han sido
          marcados como incorrectos por parte del equipo de revisores. Para poder enviar a aprobación el proyecto no
          puede haber ningun campo marcado.
        </span>
      </div>
      <div class="border-2 border-alert-base bg-neutral-100 rounded-sm px-6 py-4 flex items-start gap-3">
        <img
          src="assets/svg/alert.svg"
          alt="alert"
          class="w-4 h-4 mt-1" />
        <div class="flex flex-col">
          <span class="font-bold text-base">Proyecto PENDIENTE de subsanación</span>
          <span class="text-sm mt-1">
            Los revisores del proyecto han solicitado subsanar
            <strong>{{ initialObservedFieldsCount() }}</strong>
            {{ initialObservedFieldsCount() === 1 ? 'campo' : 'campos' }}
          </span>
        </div>
      </div>
      <div class="flex flex-col mt-8">
        <app-review-comments-block [comments]="reviewComments"></app-review-comments-block>
      </div>
      <!-- Datos identificativos -->
      <div class="flex flex-col gap-3 mt-6">
        <span class="text-[18px] font-bold mb-4">Datos indentificativos del proyecto</span>
        <div class="grid grid-cols-2 gap-4">
          <div class="flex flex-col">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('projectName') }"
                class="text-[16px]"
                for="project-name">
                Nombre del proyecto*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('projectName')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              id="project-name"
              [classes]="'w-full'"
              [placeholder]="'Nombre del sistema'"
              formControlName="projectName"></desy-input>
            <desy-error-message *ngIf="getError(form, 'projectName', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </div>

          <div class="flex flex-col min-w-0">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('userNameResponsible') }"
                class="text-[16px]"
                for="username">
                Nombre usuario responsable y puesto*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('userNameResponsible')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <p-autoComplete
              formControlName="userNameResponsible"
              [suggestions]="usersList"
              (completeMethod)="onSearchUser($event)"
              (onSelect)="onUserSelected($event)"
              placeholder="Busqueda por nombre, apellidos, jobcode o puesto"
              class="pt-2 w-full flex-1 block"
              optionLabel="infoCompleted"
              optionValue="infoCompleted"
              [forceSelection]="true"
              [ngClass]="{ 'disabled-autocomplete': form.get('userNameResponsible')?.disabled }"
              [minLength]="3">
              <ng-template
                let-item
                pTemplate="item">
                {{ item.infoCompleted }}
              </ng-template>
            </p-autoComplete>
          </div>

          <div class="flex flex-col">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('contactEmailResponsible') }"
                class="text-[16px]"
                for="contact-email-responsible">
                Correo electrónico de contacto del responsable*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('contactEmailResponsible')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              id="contact-email-responsible"
              [classes]="'w-full'"
              formControlName="contactEmailResponsible"></desy-input>
            <desy-error-message *ngIf="getError(form, 'contactEmailResponsible', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </div>

          <div class="flex flex-col">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('department') }"
                class="text-[16px]"
                for="department">
                Departamento responsable*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('department')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              id="department"
              [classes]="'w-full'"
              [placeholder]="'Departamento responsable'"
              formControlName="department"></desy-input>
          </div>

          <div class="flex flex-col flex-1 w-full">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('selectedOrgCode') }"
                class="text-[16px]"
                for="org-code">
                Nombre dirección general, SGT u organismo público responsable*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('selectedOrgCode')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <p-autoComplete
              formControlName="selectedOrgCode"
              [suggestions]="organismsList()"
              (completeMethod)="onSearchOrganization($event)"
              (onSelect)="onOrganismSelected($event)"
              placeholder="Busqueda nombre del organismo"
              class="pt-2 w-full flex-1 block"
              [ngClass]="{ 'disabled-autocomplete': form.get('selectedOrgCode')?.disabled }"
              optionLabel="organismo"
              optionValue="codigo_organismo"
              [minLength]="3">
              <ng-template
                let-item
                pTemplate="item">
                {{ item.codigo_organismo }} - {{ item.organismo }}
              </ng-template>
              <ng-template
                let-item
                pTemplate="selectedOption">
                {{ item.codigo_organismo }} - {{ item.organismo }}
              </ng-template>
            </p-autoComplete>
          </div>

          <div class="flex flex-col flex-1">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('serviceName') }"
                class="text-[16px]"
                for="service-name">
                Nombre del servicio o unidad administrativa responsable*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('serviceName')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              id="service-name"
              [classes]="'w-full'"
              formControlName="serviceName"></desy-input>
          </div>
        </div>
      </div>
      <!-- Datos funcionales -->
      <div class="flex flex-col gap-3 py-8">
        <span class="text-xl font-bold mb-4">Datos funcionales del proyecto</span>
        <div class="flex flex-col">
          <div class="flex flex-col relative">
            <label
              [ngClass]="{ 'relative -top-4': isObserved('systemFinality') }"
              class="text-[16px]"
              for="system-finality">
              Finalidad del proyecto*
            </label>
            <app-observed-field-alert
              *ngIf="isObserved('systemFinality')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <div class="text-[16px] text-neutral-dark">
              Explicación funcional del sistema de IA y problemas que resuelve
            </div>
          </div>
          <desy-textarea
            formControlName="systemFinality"
            classes="w-full text-[16px]"
            class="w-full"
            [rows]="5"
            [maxlength]="500"></desy-textarea>
          <desy-error-message *ngIf="getError(form, 'systemFinality', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>

          <div class="grid grid-cols-2 gap-4 mb-4">
            <div class="flex flex-col col-span-2 gap-2 justify-between mb-8">
              <div class="flex flex-col">
                <div class="flex flex-col relative">
                  <label
                    [ngClass]="{ 'relative -top-4': isObserved('selectedProcedure') }"
                    class="text-[16px]"
                    for="selected-procedure">
                    Procedimientos administrativos*
                  </label>
                  <app-observed-field-alert
                    *ngIf="isObserved('selectedProcedure')"
                    class="absolute top-2 left-0"></app-observed-field-alert>
                </div>
                <span class="text-neutral-dark text-[16px]">
                  En caso de no haber correspondencia, contacte con su unidad de apoyo de administración electrónica.
                </span>
              </div>
              <div class="procedure-autocomplete-field">
                <p-autoComplete
                  #procedureAutocomplete
                  [(ngModel)]="procedureSearch"
                  [ngModelOptions]="{ standalone: true }"
                  [suggestions]="proceduresList"
                  (completeMethod)="onSearchProcedure($event)"
                  (onSelect)="onProcedureSelected($event)"
                  (onFocus)="clearProcedureSearch()"
                  (keydown.enter)="onProcedureSearchEnter($event, procedureAutocomplete)"
                  [forceSelection]="true"
                  placeholder="Búsqueda de procedimiento"
                  optionLabel="name"
                  [minLength]="3"
                  [dropdown]="false"
                  [inputStyle]="{ width: '100%', 'padding-right': '2.75rem' }">
                  <ng-template
                    let-item
                    pTemplate="item">
                    {{ item.code }} - {{ item.name }}
                  </ng-template>
                  <ng-template pTemplate="loadingicon"></ng-template>
                  <ng-template pTemplate="empty">
                    @if (procedureSearchLoading) {
                      <div class="procedure-loading-row">
                        <span>Cargando resultados</span>
                        <i class="pi pi-spinner pi-spin"></i>
                      </div>
                    } @else {
                      No se encontraron resultados
                    }
                  </ng-template>
                </p-autoComplete>
                <button
                  type="button"
                  class="procedure-search-button"
                  aria-label="Buscar procedimiento"
                  (mousedown)="$event.preventDefault()"
                  (click)="searchCurrentProcedure(procedureAutocomplete, $event)">
                  <i class="pi pi-search"></i>
                </button>
              </div>
              <div class="flex gap-1 flex-wrap">
                <app-pill
                  *ngFor="let proc of currentProcedures()"
                  [value]="proc.code + ' - ' + proc.name"
                  [isDeletable]="true"
                  [classe]="'c-pill--primary'"
                  (accions)="removeProcedure(proc.code)"></app-pill>
              </div>
              <div class="mt-24 py-2 absolute"></div>
              <desy-error-message *ngIf="getError(form, 'selectedProcedure', formSubmitted()) as error">
                {{ error }}
              </desy-error-message>
            </div>
            <div class="flex flex-col col-span-1 justify-end">
              <div class="flex flex-col relative">
                <label
                  [ngClass]="{ 'relative -top-4': isObserved('systemOrApp') }"
                  class="text-[16px]"
                  for="system-or-app">
                  Aplicaciones o sistemas relacionados*
                </label>
                <app-observed-field-alert
                  *ngIf="isObserved('systemOrApp')"
                  class="absolute top-2 left-0"></app-observed-field-alert>
              </div>
              <div class="flex flex-col">
                <div class="flex flex-row gap-2">
                  <div class="w-full items-end">
                    <desy-input
                      id="system-or-app"
                      [classes]="'w-full'"
                      [placeholder]="'Aplicaciones o sistemas relacionados'"
                      [ngModel]="application()"
                      (ngModelChange)="application.set($event)"
                      [ngModelOptions]="{ standalone: true }"></desy-input>
                  </div>
                  <div class="mt-2">
                    <app-buttons
                      type="button"
                      (click)="addApplication($event)"
                      [label]="'Añadir'"
                      [classes]="'bg-primary-base text-white'"></app-buttons>
                  </div>
                </div>
              </div>
              <div class="flex gap-1 flex-wrap -mt-5">
                @for (item of applications(); track item) {
                  <app-pill
                    [value]="item"
                    [isDeletable]="true"
                    [classe]="'c-pill--primary'"
                    (accions)="removeApplication(item)" />
                }
              </div>
              <desy-error-message *ngIf="getError(form, 'systemOrApp', formSubmitted()) as error">
                {{ error }}
              </desy-error-message>
            </div>
          </div>
          <div class="flex flex-col relative mt-2">
            <label
              [ngClass]="{ 'relative -top-4': isObserved('administrativeProcess') }"
              class="text-[16px]">
              Trámite administrativo o proceso involucrado
            </label>

            <app-observed-field-alert
              *ngIf="isObserved('administrativeProcess')"
              class="absolute top-2 left-0"></app-observed-field-alert>
            <div class="text-[16px] text-neutral-dark">
              En caso de no afectar a ningún servicio o procedimiento administrativo incluido en SEDA, indicar los
              servicios, trámites o procesos involucrados
            </div>
          </div>
          <desy-textarea
            formControlName="administrativeProcess"
            classes="w-full"
            class="w-full"
            [rows]="5"
            [maxlength]="500"></desy-textarea>
        </div>
      </div>
      <!-- Datos económicos -->
      <div class="flex flex-col gap-3">
        <span class="text-xl font-bold mb-4">Datos económicos del proyecto</span>
        <div class="grid grid-cols-2 items-end gap-4">
          <div class="flex flex-col col-span-2 gap-4 items-stretch">
            <div
              class="flex flex-col gap-4"
              formArrayName="before">
              <div class="flex w-full items-center justify-between gap-4">
                <label
                  [ngClass]="{
                    'relative -top-4': isAnyObserved([
                      'totalPeopleBefore',
                      'groupAdministrationBefore',
                      'levelPositionBefore',
                    ]),
                  }"
                  class="text-[16px] font-semibold flex-1 max-w-[820px] mt-2"
                  for="total-people-before-0">
                  Empleados públicos de la unidad o servicio implicados en la tramitación del procedimiento o servicio
                  antes del despliegue del proyecto IA*
                </label>
                <desy-button
                  class="flex-shrink-0"
                  [type]="'button'"
                  classes="c-button c-button--primary ng-star-inserted"
                  (clickEvent)="addBeforeRow()">
                  Añadir registro
                </desy-button>
              </div>
              <span class="text-[16px] text-neutral-dark">
                Cada registro debe tener cumplimentados los 3 campos obligatorios.
              </span>
              <desy-table-advanced
                classes="min-w-full employee-table"
                idPrefix="table-before-employees"
                [wrapper]="{ classes: 'overflow-x-auto' }">
                <desy-table-advanced-header>
                  <desy-table-advanced-header-cell>
                    <desy-content>
                      <div class="employee-observed-header">
                        <span>Total de empleados públicos antes del despliegue*</span>
                        <app-observed-field-alert *ngIf="isObserved('totalPeopleBefore')"></app-observed-field-alert>
                      </div>
                    </desy-content>
                  </desy-table-advanced-header-cell>
                  <desy-table-advanced-header-cell>
                    <desy-content>
                      <div class="employee-observed-header">
                        <span>Grupo de administración antes del despliegue*</span>
                        <app-observed-field-alert
                          *ngIf="isObserved('groupAdministrationBefore')"></app-observed-field-alert>
                      </div>
                    </desy-content>
                  </desy-table-advanced-header-cell>
                  <desy-table-advanced-header-cell>
                    <desy-content>
                      <div class="employee-observed-header">
                        <span>Nivel de puesto antes del despliegue*</span>
                        <app-observed-field-alert *ngIf="isObserved('levelPositionBefore')"></app-observed-field-alert>
                      </div>
                    </desy-content>
                  </desy-table-advanced-header-cell>
                  <desy-table-advanced-header-cell>
                    <desy-content>Acción</desy-content>
                  </desy-table-advanced-header-cell>
                </desy-table-advanced-header>
                @for (row of beforeEmployeeRows; track $index) {
                  <desy-table-advanced-row [formGroupName]="$index">
                    <desy-table-advanced-row-cell>
                      <desy-input
                        [id]="'total-people-before-' + $index"
                        [classes]="'w-full'"
                        type="number"
                        step="0.01"
                        min="0"
                        inputmode="decimal"
                        formControlName="totalPeople"></desy-input>
                      <desy-error-message *ngIf="getEmployeeRowError(row, 'totalPeople') as error">
                        {{ error }}
                      </desy-error-message>
                    </desy-table-advanced-row-cell>
                    <desy-table-advanced-row-cell>
                      <desy-input
                        [id]="'group-administration-before-' + $index"
                        [classes]="'w-full'"
                        type="text"
                        formControlName="groupAdministration"></desy-input>
                      <desy-error-message *ngIf="getEmployeeRowError(row, 'groupAdministration') as error">
                        {{ error }}
                      </desy-error-message>
                    </desy-table-advanced-row-cell>
                    <desy-table-advanced-row-cell>
                      <desy-input
                        [id]="'level-position-before-' + $index"
                        [classes]="'w-full'"
                        type="number"
                        step="1"
                        min="0"
                        inputmode="numeric"
                        formControlName="levelPosition"></desy-input>
                      <desy-error-message *ngIf="getEmployeeRowError(row, 'levelPosition') as error">
                        {{ error }}
                      </desy-error-message>
                    </desy-table-advanced-row-cell>
                    <desy-table-advanced-row-cell classes="employee-action-cell">
                      <div class="employee-action-cell__content">
                        <app-buttons
                          type="button"
                          [label]="'Eliminar'"
                          [classes]="'bg-secondary-base text-secondary-light'"
                          [disabled]="before.length <= 1"
                          (click)="removeBeforeRow($index)" />
                      </div>
                    </desy-table-advanced-row-cell>
                  </desy-table-advanced-row>
                }
              </desy-table-advanced>
            </div>

            <div
              class="flex flex-col gap-4"
              formArrayName="after">
              <div class="flex w-full items-center justify-between gap-4">
                <label
                  [ngClass]="{
                    'relative -top-4': isAnyObserved([
                      'totalPeopleAfter',
                      'groupAdministrationAfter',
                      'levelPositionAfter',
                    ]),
                  }"
                  class="text-[16px] font-semibold flex-1 max-w-[820px] mt-8"
                  for="total-people-after-0">
                  Empleados públicos de la unidad o servicio implicados en la tramitación del procedimiento o servicio
                  tras el despliegue del proyecto IA*
                </label>
                <desy-button
                  class="flex-shrink-0"
                  [type]="'button'"
                  classes="c-button c-button--primary ng-star-inserted"
                  (clickEvent)="addAfterRow()">
                  Añadir registro
                </desy-button>
              </div>
              <span class="text-[16px] text-neutral-dark -mt-4">
                Cada registro debe tener cumplimentados los 3 campos obligatorios.
              </span>
              <desy-table-advanced
                classes="min-w-full employee-table"
                idPrefix="table-after-employees"
                [wrapper]="{ classes: 'overflow-x-auto' }">
                <desy-table-advanced-header>
                  <desy-table-advanced-header-cell>
                    <desy-content>
                      <div class="employee-observed-header">
                        <span>Total de empleados públicos tras el despliegue*</span>
                        <app-observed-field-alert *ngIf="isObserved('totalPeopleAfter')"></app-observed-field-alert>
                      </div>
                    </desy-content>
                  </desy-table-advanced-header-cell>
                  <desy-table-advanced-header-cell>
                    <desy-content>
                      <div class="employee-observed-header">
                        <span>Grupo de administración tras el despliegue*</span>
                        <app-observed-field-alert
                          *ngIf="isObserved('groupAdministrationAfter')"></app-observed-field-alert>
                      </div>
                    </desy-content>
                  </desy-table-advanced-header-cell>
                  <desy-table-advanced-header-cell>
                    <desy-content>
                      <div class="employee-observed-header">
                        <span>Nivel de puesto tras el despliegue*</span>
                        <app-observed-field-alert *ngIf="isObserved('levelPositionAfter')"></app-observed-field-alert>
                      </div>
                    </desy-content>
                  </desy-table-advanced-header-cell>
                  <desy-table-advanced-header-cell>
                    <desy-content>Acción</desy-content>
                  </desy-table-advanced-header-cell>
                </desy-table-advanced-header>
                @for (row of afterEmployeeRows; track $index) {
                  <desy-table-advanced-row [formGroupName]="$index">
                    <desy-table-advanced-row-cell>
                      <desy-input
                        [id]="'total-people-after-' + $index"
                        [classes]="'w-full'"
                        type="number"
                        step="0.01"
                        min="0"
                        inputmode="decimal"
                        formControlName="totalPeople"></desy-input>
                      <desy-error-message *ngIf="getEmployeeRowError(row, 'totalPeople') as error">
                        {{ error }}
                      </desy-error-message>
                    </desy-table-advanced-row-cell>
                    <desy-table-advanced-row-cell>
                      <desy-input
                        [id]="'group-administration-after-' + $index"
                        [classes]="'w-full'"
                        type="text"
                        formControlName="groupAdministration"></desy-input>
                      <desy-error-message *ngIf="getEmployeeRowError(row, 'groupAdministration') as error">
                        {{ error }}
                      </desy-error-message>
                    </desy-table-advanced-row-cell>
                    <desy-table-advanced-row-cell>
                      <desy-input
                        [id]="'level-position-after-' + $index"
                        [classes]="'w-full'"
                        type="number"
                        step="1"
                        min="0"
                        inputmode="numeric"
                        formControlName="levelPosition"></desy-input>
                      <desy-error-message *ngIf="getEmployeeRowError(row, 'levelPosition') as error">
                        {{ error }}
                      </desy-error-message>
                    </desy-table-advanced-row-cell>
                    <desy-table-advanced-row-cell classes="employee-action-cell">
                      <div class="employee-action-cell__content">
                        <app-buttons
                          type="button"
                          [label]="'Eliminar'"
                          [classes]="'bg-secondary-base text-secondary-light'"
                          [disabled]="after.length <= 1"
                          (click)="removeAfterRow($index)" />
                      </div>
                    </desy-table-advanced-row-cell>
                  </desy-table-advanced-row>
                }
              </desy-table-advanced>
            </div>
          </div>
          <div class="flex flex-col">
            <div class="h-6"></div>
            <label
              [ngClass]="{
                'relative -top-4': isAnyObserved(['amountAffectedCitizens', 'amountAffectedOfficials']),
              }"
              class="text-[16px] font-semibold">
              Número de personas afectadas por el proceso*
            </label>
            <div class="flex gap-2">
              <div class="flex flex-col flex-1">
                <div class="flex flex-col relative">
                  <app-observed-field-alert
                    *ngIf="isObserved('amountAffectedCitizens')"
                    class="absolute -top-4 left-0"></app-observed-field-alert>
                </div>
                <span class="text-[16px] text-neutral-dark">Ciudadanos*</span>
                <desy-input
                  [classes]="'w-full'"
                  type="number"
                  formControlName="amountAffectedCitizens"></desy-input>
                <desy-error-message *ngIf="getError(form, 'amountAffectedCitizens', formSubmitted()) as error">
                  {{ error }}
                </desy-error-message>
              </div>
              <div class="flex flex-col flex-1">
                <div class="flex flex-col relative">
                  <app-observed-field-alert
                    *ngIf="isObserved('amountAffectedOfficials')"
                    class="absolute -top-4 left-0"></app-observed-field-alert>
                </div>
                <span class="text-[16px] text-neutral-dark">Funcionarios*</span>
                <desy-input
                  [classes]="'w-full'"
                  type="number"
                  formControlName="amountAffectedOfficials"></desy-input>
                <desy-error-message *ngIf="getError(form, 'amountAffectedOfficials', formSubmitted()) as error">
                  {{ error }}
                </desy-error-message>
              </div>
            </div>
          </div>

          <div class="flex flex-col relative">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('economicEstimateImplementation') }"
                class="text-[16px]"
                for="economic-estimate-implementation">
                Estimación económica de implantación (€)*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('economicEstimateImplementation')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              [classes]="'w-full'"
              type="number"
              step="0.01"
              min="0"
              formControlName="economicEstimateImplementation"></desy-input>
            <desy-error-message *ngIf="getError(form, 'economicEstimateImplementation', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </div>
          <div class="flex flex-col relative">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('economicEstimateAnnualMaintenance') }"
                class="text-[16px]">
                Estimación económica de mantenimiento anual (€)
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('economicEstimateAnnualMaintenance')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              [classes]="'w-full'"
              type="number"
              step="0.01"
              min="0"
              formControlName="economicEstimateAnnualMaintenance"></desy-input>
          </div>

          <div class="flex flex-col relative">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('economicEstimateConsumption') }"
                class="text-[16px]">
                Estimación económica de consumo (€)
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('economicEstimateConsumption')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              [classes]="'w-full'"
              type="number"
              step="0.01"
              min="0"
              formControlName="economicEstimateConsumption"></desy-input>
          </div>

          <div class="flex flex-col relative">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('currentApplicationCostEstimate') }"
                class="text-[16px]">
                Estimación del coste de aplicación actual (€)*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('currentApplicationCostEstimate')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              [classes]="'w-full'"
              type="number"
              step="0.01"
              min="0"
              formControlName="currentApplicationCostEstimate"></desy-input>
            <desy-error-message *ngIf="getError(form, 'currentApplicationCostEstimate', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </div>

          <div class="flex flex-col relative">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('otherDerivedCosts') }"
                class="text-[16px]">
                Otros costes derivados
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('otherDerivedCosts')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              [classes]="'w-full'"
              type="text"
              formControlName="otherDerivedCosts"></desy-input>
          </div>

          <div class="flex flex-col relative">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('currentStaffCostEstimate') }"
                class="text-[16px]">
                Estimación del coste del personal actual*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('currentStaffCostEstimate')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              [classes]="'w-full'"
              type="number"
              step="0.01"
              min="0"
              formControlName="currentStaffCostEstimate"></desy-input>
            <desy-error-message *ngIf="getError(form, 'currentStaffCostEstimate', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </div>

          <div class="flex flex-col relative">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('postDeploymentStaffCostEstimate') }"
                class="text-[16px]">
                Estimación del coste del personal tras el despliegue*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('postDeploymentStaffCostEstimate')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-input
              [classes]="'w-full'"
              type="number"
              step="0.01"
              min="0"
              formControlName="postDeploymentStaffCostEstimate"></desy-input>
            <desy-error-message *ngIf="getError(form, 'postDeploymentStaffCostEstimate', formSubmitted()) as error">
              {{ error }}
            </desy-error-message>
          </div>

          <div class="flex flex-col">
            <label
              [ngClass]="{
                'relative -top-4': isAnyObserved(['averageResolutionEstimateTime', 'averageResolutionRealTime']),
              }"
              class="text-[16px] font-semibold mb-2">
              Plazo medio de resolución (en meses) *
            </label>
            <div class="flex gap-2">
              <div class="flex flex-col flex-1">
                <div class="flex flex-col relative">
                  <app-observed-field-alert
                    *ngIf="isObserved('averageResolutionEstimateTime')"
                    class="absolute -top-4 left-0"></app-observed-field-alert>
                  <label class="text-[16px] text-neutral-dark">Meses estimados tras implantar IA*</label>
                </div>
                <desy-input
                  type="number"
                  [classes]="'w-full'"
                  formControlName="averageResolutionEstimateTime"></desy-input>
              </div>
              <div class="flex flex-col flex-1">
                <div class="flex flex-col relative">
                  <label class="text-[16px] text-neutral-dark">Meses actualmente*</label>
                  <app-observed-field-alert
                    *ngIf="isObserved('averageResolutionRealTime')"
                    class="absolute -top-4 left-0"></app-observed-field-alert>
                </div>
                <desy-input
                  type="number"
                  [classes]="'w-full'"
                  formControlName="averageResolutionRealTime"></desy-input>
                <desy-error-message *ngIf="getError(form, 'averageResolutionRealTime', formSubmitted()) as error">
                  {{ error }}
                </desy-error-message>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Datos de entrada -->
      <div class="flex flex-col gap-3 py-8">
        <span class="text-xl font-bold mb-4">Datos de entrada</span>
        <div class="flex gap-4">
          <div class="flex flex-col flex-1">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('personalSelectedDataType') }"
                class="text-[16px]"
                for="type-data-personal">
                Datos personales tratados por el sistema de IA
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('personalSelectedDataType')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-select
              formControlName="personalSelectedDataType"
              classes="min-w-full mt-2">
              <desy-label>Selecciona tipo de dato</desy-label>
              <desy-option
                [disabled]="true"
                [selected]="true"
                [hidden]="true">
                Selecciona una opcion
              </desy-option>
              <desy-option
                *ngFor="let item of typeDataPersonal"
                [id]="item.label"
                [value]="item.value">
                {{ item.label }}
              </desy-option>
            </desy-select>
          </div>

          <div
            class="flex flex-col flex-1"
            *ngIf="form.get('personalSelectedDataType')?.value !== 1"></div>
          <div
            class="flex flex-col flex-1"
            *ngIf="form.get('personalSelectedDataType')?.value === 1">
            <label class="text-[16px]">Categoría de datos personales tratados*</label>

            <p-multiSelect
              [options]="categoryDataPersonal"
              [filter]="false"
              [showToggleAll]="false"
              formControlName="categoryDataPersonalSelected"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecciona categorías"
              class="mt-8"
              [panelStyleClass]="'custom-multiselect-panel'">
              <ng-template
                let-values
                pTemplate="selectedItems">
                {{ getSelectedCategoriesText(values) }}
              </ng-template>
            </p-multiSelect>
          </div>
        </div>

        <div class="flex flex-col gap-3">
          <div *ngIf="hasBiometricCategory() || isObserved('biometricData')">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('biometricData') }"
                class="text-md">
                Tratamiento de datos biométricos*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('biometricData')"
                class="absolute top-2 left-0"></app-observed-field-alert>
              <div class="text-[16px] text-neutral-dark mt-2">
                Explicación de los datos biométricos y qué actividad de tratamiento tiene.
              </div>
            </div>
            <desy-textarea
              formControlName="biometricData"
              classes="w-full"
              class="w-full"
              [rows]="5"
              [maxlength]="500"></desy-textarea>
          </div>
          <desy-error-message *ngIf="getError(form, 'biometricData', formSubmitted()) as error">
            {{ error }}
          </desy-error-message>

          <div class="grid grid-cols-2 gap-4">
            <div class="flex flex-col col-span-1">
              <div class="flex flex-col relative">
                <label
                  [ngClass]="{ 'relative -top-4': isObserved('RAT') }"
                  class="text-[16px]"
                  for="RAT">
                  Actividad de tratamiento publicada en el Registro de Actividades de Tratamiento del Gobierno de Aragon
                  (RAT)*
                </label>
                <app-observed-field-alert
                  *ngIf="isObserved('RAT')"
                  class="absolute top-8 left-0"></app-observed-field-alert>
              </div>
              <div class="text-[16px] text-neutral-dark">
                Escriba el código RAT para que la aplicación complete el nombre de la actividad
              </div>
              <desy-input
                id="RAT"
                [classes]="'w-full'"
                [placeholder]="'Escriba el codigo RAT'"
                formControlName="RAT"></desy-input>
              <desy-error-message *ngIf="getError(form, 'RAT', formSubmitted()) as error">
                {{ error }}
              </desy-error-message>
            </div>
            <div class="col-span-1"></div>
          </div>
          <div class="flex flex-col">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('eipd') }"
                class="text-[16px] font-bold">
                Evaluación de impacto en la protección de datos personales (EIPD)*
              </label>

              <app-observed-field-alert
                *ngIf="isObserved('eipd')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-radios
              formControlName="isDataSensitive"
              name="rat-treatment"
              idPrefix="rat"
              class="mt-4">
              <desy-radio-item value="no-realizada">
                <desy-label>No realizada</desy-label>
              </desy-radio-item>

              <desy-radio-item
                value="seleccionar-fecha"
                [conditional]="true">
                <desy-label>Fecha evaluación de impacto</desy-label>

                <desy-content>
                  <div class="mt-2">
                    <label class="text-[16px] block">Fecha</label>

                    <label class="text-[16px] mb-2 block text-neutral-dark">
                      La fecha seleccionada debe ser anterior a hoy ({{ currentDateFormatted }})
                    </label>

                    <p-datepicker
                      formControlName="eipd"
                      dateFormat="dd-mm-yy"
                      [iconDisplay]="'input'"
                      [showIcon]="true"
                      inputStyleClass="mi-input"
                      placeholder="dd-mm-aaaa"
                      class="w-full"></p-datepicker>

                    <desy-error-message *ngIf="getError(form, 'eipd', formSubmitted()) as error">
                      {{ error }}
                    </desy-error-message>
                    <div class="flex flex-col relative mt-4">
                      <label
                        [ngClass]="{ 'relative -top-4': isObserved('csvEipd') }"
                        class="text-[16px] block"
                        for="csvEipd">
                        CSV*
                      </label>
                      <app-observed-field-alert
                        *ngIf="isObserved('csvEipd')"
                        class="absolute top-2 left-0"></app-observed-field-alert>
                      <desy-input
                        id="csvEipd"
                        [classes]="'w-[48%]'"
                        [placeholder]="'Código identificador del documento'"
                        formControlName="csvEipd"></desy-input>
                      <desy-error-message *ngIf="getError(form, 'csvEipd', formSubmitted()) as error">
                        {{ error }}
                      </desy-error-message>
                    </div>
                  </div>
                </desy-content>
              </desy-radio-item>
            </desy-radios>
          </div>
        </div>
      </div>
      <!-- nivel de Riesgo -->
      <div class="flex flex-col gap-3">
        <span class="text-xl font-bold mb-4">Gestión del riesgo</span>
        <div class="flex gap-4">
          <div class="flex flex-col flex-1">
            <div class="flex flex-col relative">
              <label
                [ngClass]="{ 'relative -top-4': isObserved('projectClassification') }"
                class="text-[16px]"
                for="projectClassification">
                Clasificacion del sistema de IA según su nivel de riesgo*
              </label>
              <app-observed-field-alert
                *ngIf="isObserved('projectClassification')"
                class="absolute top-2 left-0"></app-observed-field-alert>
            </div>
            <desy-select
              formControlName="projectClassification"
              classes="w-[50%] mt-2">
              <desy-label>Selecciona el nivel de riesgo</desy-label>
              <desy-option
                [disabled]="true"
                [selected]="true"
                [hidden]="true">
                Selecciona un valor
              </desy-option>
              <desy-option
                *ngFor="let item of riskLevelOptions"
                [id]="item.label"
                [value]="item.value">
                {{ item.label }}
              </desy-option>
            </desy-select>
          </div>
        </div>
        <desy-error-message *ngIf="getError(form, 'projectClassification', formSubmitted()) as error">
          {{ error }}
        </desy-error-message>
      </div>
    </div>
  </form>
  <p-confirmDialog></p-confirmDialog>
</div>
